import React from "react"

function Friendship({ width = 24, height = 24, fill = "none", ...props }) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="6 6 24 24"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <circle
        cx="14.25"
        cy="11.125"
        r="2.25"
        stroke="#003E4C"
        strokeWidth="1"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <circle
        cx="21.75"
        cy="11.125"
        r="2.25"
        stroke="#003E4C"
        strokeWidth="1"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.5 16.125C10.5 15.09 11.34 14.25 12.375 14.25H23.625C24.66 14.25 25.5 15.09 25.5 16.125V19.875C25.5 20.22 25.22 20.5 24.875 20.5H24.25V25.5C24.25 25.845 23.97 26.125 23.625 26.125H20.5C20.155 26.125 19.875 25.845 19.875 25.5V18H19.25"
        stroke="#003E4C"
        strokeWidth="1"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M25.5 16.125C25.5 15.09 24.66 14.25 23.625 14.25H12.375C11.34 14.25 10.5 15.09 10.5 16.125V19.875C10.5 20.22 10.78 20.5 11.125 20.5H11.75V25.5C11.75 25.845 12.03 26.125 12.375 26.125H15.5C15.845 26.125 16.125 25.845 16.125 25.5V18H16.75"
        stroke="#003E4C"
        strokeWidth="1"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
export default Friendship
